<template>
  <div>
    <div
      v-if="Object.keys(userData).length"
      id="user-profile"
      class="container px-0"
    >
      <profile-header :user-data="userData" @updateUser="getUser" />
      <transition name="fade" mode="out-in">
        <router-view
          :user-data="userData"
          :loading="loading"
          :seenSessions="
            userData.seen_sessions ? userData.seen_sessions.sessions : []
          "
        />
        <!-- :courses="userData.courses.courses" -->
      </transition>
    </div>
    <loader :loading="loading" />
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";

import ProfileHeader from "./profile-header/ProfileHeader.vue";
import loader from "@core/components/loader/Loader.vue";
export default {
  components: {
    BRow,
    BCol,
    loader,
    ProfileHeader,
  },
  data() {
    return {
      userData: {},
      loading: false,
    };
  },
  watch: {
    $route: {
      async handler(newVal, oldVal) {
        if (
          oldVal &&
          newVal &&
          oldVal.matched[0].path !== newVal.matched[0].path
        ) {
          const token = (await JSON.parse(localStorage.getItem("user_token")))
            ? JSON.parse(localStorage.getItem("user_token"))
            : JSON.parse(localStorage.getItem("token"));
          if (token)
            this.$http.defaults.headers.common["Authorization"] =
              await `${token.type} ${token.val}`;
          await this.getUser();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    const token = (await JSON.parse(localStorage.getItem("user_token")))
      ? JSON.parse(localStorage.getItem("user_token"))
      : JSON.parse(localStorage.getItem("token"));
    if (token)
      this.$http.defaults.headers.common["Authorization"] =
        await `${token.type} ${token.val}`;
    await this.getUser();
  },
  methods: {
    async getUser() {
      this.loading = true;
      if (this.$route.params.id) {
        try {
          const { data } = await this.$http.get(
            `/panel/users/${this.$route.params.id}`,
            {
              params: {
                includes: [
                  "semesters.roadmaps.item",
                  "events",
                  "seen_sessions.course",
                ],
              },
            }
          );
          this.userData = data.data;
        } catch (err) {}
      } else {
        try {
          const { data } = await this.$http.get(`/panel/profile`, {
            params: {
              includes: ["semesters.roadmaps.item"],
            },
          });
          if (
            !data.data.mobile_verified_at &&
            !localStorage.getItem("user_token")
          ) {
            this.$store.dispatch("auth/setVisibleCheckUser", true);
            this.$store.dispatch("auth/setVerifyType", "mobile");
          }
          if (
            !data.data.email_verified_at &&
            !localStorage.getItem("user_token")
          ) {
            this.$store.dispatch("auth/setVisibleCheckUser", true);
            this.$store.dispatch("auth/setVerifyType", "email");
          }
          this.userData = data.data;
        } catch (err) {}
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-profile.scss";
</style>
<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
